import { render, staticRenderFns } from "./countryLanguage.vue?vue&type=template&id=65ecccbb&"
import script from "./countryLanguage.vue?vue&type=script&lang=js&"
export * from "./countryLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ecccbb')) {
      api.createRecord('65ecccbb', component.options)
    } else {
      api.reload('65ecccbb', component.options)
    }
    module.hot.accept("./countryLanguage.vue?vue&type=template&id=65ecccbb&", function () {
      api.rerender('65ecccbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/countryLanguage.vue"
export default component.exports